$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,42,1) 35%, rgba(0,212,255,1) 100%); color: #FFF; font-weight: bold; font-size: 50px;"
);



////////home banner splide



 if ($("#splide1").length == 1 && $("#splide2").length == 1 && $("#splide3").length == 1 && $("#splide4").length == 1) {
    // splide
    const splide = new Splide("#splide1", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      dots: "false",
      perPage: 4,
      autoScroll: {
        speed: 1,
      },
      // Responsive breakpoint
      breakpoints: {
        991: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
        },
      },
    });

    const splide1 = new Splide("#splide2", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      perPage: 4,
      autoScroll: {
        speed: -1,
      },
      // Responsive breakpoint
      breakpoints: {
        991: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
        },
      },
    });

   const splide2 = new Splide("#splide3", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      dots: "false",
      perPage: 4,
      autoScroll: {
        speed: 1,
      },
      // Responsive breakpoint
      breakpoints: {
        991: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
        },
      },
    });

  const splide3 = new Splide("#splide4", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      perPage: 4,
      autoScroll: {
        speed: -1,
      },
      // Responsive breakpoint
      breakpoints: {
        991: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
        },
      },
    });

    splide.mount(window.splide.Extensions);
    splide1.mount(window.splide.Extensions);
    splide2.mount(window.splide.Extensions);
    splide3.mount(window.splide.Extensions);
  } //end if


  
//Home Shop Collection Slider

$('.indx-1-slider').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 1,
   slidesToScroll: 1,
   adaptiveHeight: false,
   prevArrow:'<div class="slick-prev pull-left"><svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.15784 8.1576L0.956775 4.95653C0.850653 4.85041 0.791035 4.70648 0.791035 4.5564C0.791035 4.40632 0.850653 4.26239 0.956775 4.15626L4.15784 0.955197C4.23694 0.875813 4.33783 0.821703 4.44772 0.799727C4.55761 0.777751 4.67156 0.788899 4.7751 0.831758C4.87865 0.874617 4.96714 0.947257 5.02935 1.04047C5.09157 1.13368 5.1247 1.24326 5.12456 1.35533L5.12376 3.99061L23.7644 3.98981V5.12298L5.12376 5.12219L5.12456 7.75746C5.1247 7.86953 5.09157 7.97911 5.02935 8.07233C4.96714 8.16554 4.87865 8.23818 4.7751 8.28103C4.67156 8.32389 4.55761 8.33504 4.44772 8.31307C4.33783 8.29109 4.23694 8.23698 4.15784 8.1576Z" fill="currentColor"/></svg></div>',
   nextArrow:'<div class="slick-next pull-right"><svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.8422 8.1576L23.0432 4.95653C23.1493 4.85041 23.209 4.70648 23.209 4.5564C23.209 4.40632 23.1493 4.26239 23.0432 4.15626L19.8422 0.955197C19.7631 0.875813 19.6622 0.821703 19.5523 0.799727C19.4424 0.777751 19.3284 0.788899 19.2249 0.831758C19.1213 0.874617 19.0329 0.947257 18.9706 1.04047C18.9084 1.13368 18.8753 1.24326 18.8754 1.35533L18.8762 3.99061L0.23563 3.98981V5.12298L18.8762 5.12219L18.8754 7.75746C18.8753 7.86953 18.9084 7.97911 18.9706 8.07233C19.0329 8.16554 19.1213 8.23818 19.2249 8.28103C19.3284 8.32389 19.4424 8.33504 19.5523 8.31307C19.6622 8.29109 19.7631 8.23698 19.8422 8.1576Z" fill="currentColor"/></svg></div>',
   responsive: [
     {
       breakpoint: 1440,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });


// home featured collection slider


  $('.indx-3-slider').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 5,
   slidesToScroll: 1,
   adaptiveHeight: false,
   prevArrow:'<div class="slick-prev pull-left"><svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.15784 8.1576L0.956775 4.95653C0.850653 4.85041 0.791035 4.70648 0.791035 4.5564C0.791035 4.40632 0.850653 4.26239 0.956775 4.15626L4.15784 0.955197C4.23694 0.875813 4.33783 0.821703 4.44772 0.799727C4.55761 0.777751 4.67156 0.788899 4.7751 0.831758C4.87865 0.874617 4.96714 0.947257 5.02935 1.04047C5.09157 1.13368 5.1247 1.24326 5.12456 1.35533L5.12376 3.99061L23.7644 3.98981V5.12298L5.12376 5.12219L5.12456 7.75746C5.1247 7.86953 5.09157 7.97911 5.02935 8.07233C4.96714 8.16554 4.87865 8.23818 4.7751 8.28103C4.67156 8.32389 4.55761 8.33504 4.44772 8.31307C4.33783 8.29109 4.23694 8.23698 4.15784 8.1576Z" fill="currentColor"/></svg></div>',
   nextArrow:'<div class="slick-next pull-right"><svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.8422 8.1576L23.0432 4.95653C23.1493 4.85041 23.209 4.70648 23.209 4.5564C23.209 4.40632 23.1493 4.26239 23.0432 4.15626L19.8422 0.955197C19.7631 0.875813 19.6622 0.821703 19.5523 0.799727C19.4424 0.777751 19.3284 0.788899 19.2249 0.831758C19.1213 0.874617 19.0329 0.947257 18.9706 1.04047C18.9084 1.13368 18.8753 1.24326 18.8754 1.35533L18.8762 3.99061L0.23563 3.98981V5.12298L18.8762 5.12219L18.8754 7.75746C18.8753 7.86953 18.9084 7.97911 18.9706 8.07233C19.0329 8.16554 19.1213 8.23818 19.2249 8.28103C19.3284 8.32389 19.4424 8.33504 19.5523 8.31307C19.6622 8.29109 19.7631 8.23698 19.8422 8.1576Z" fill="currentColor"/></svg></div>',
   responsive: [
     {
       breakpoint: 1440,
       settings: {
         slidesToShow: 5,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 480,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     }
   ]
 });



//for FAQ

  
$(function() {
$('.accordion .acc-headng-main').click(function(){
$(this).parent().toggleClass(' active ');
$(this).parent().siblings().removeClass('active');

$(this).parent().children(".content-box").toggleClass('open').slideToggle();
$(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
return false;
});
});



  
  

  
//for smooth scroll

  
  // $('.scrlbtm a').on('click', function (event) {
  //   event.preventDefault(); // Prevent default anchor click behavior

  //   const target = $($(this).attr('href')); // Get the target element using the href value
  //   if (target.length) {
  //     $('html, body').animate(
  //       {
  //         scrollTop: target.offset().top, // Scroll to the target's top position
  //       },
  //       800, // Duration in milliseconds
  //       'swing' // Easing function
  //     );
  //   }
  // });




// Home Testimonial after before img

// document.querySelectorAll('.indxSec7-holder').forEach((holder) => {
//   const imgAfter = holder.querySelector('.img-wrapper:nth-of-type(2)');
//   const line = holder.querySelector('#line');
//   const sliderNew = holder.querySelector('#sliderBar');

//   if (imgAfter && line && sliderNew) {
//     sliderNew.addEventListener('input', () => {
//       const value = sliderNew.value;
//       line.style.left = `${value}%`;   
//       imgAfter.style.clipPath = `inset(0px 0px 0px ${value}%)`;
//     });

//     // Reset on double-click
//     sliderNew.addEventListener('dblclick', () => {
//       sliderNew.value = 50;
//       line.style.left = '50%';
//       imgAfter.style.clipPath = 'inset(0px 0px 0px 50%)';
//     });
//   }
// });



  
  

//index 5 slider
// var $slider = $('.indx-5-slider');
//   var $progressBar = $('.progress');
//   var $progressBarLabel = $( '.slider__label' );
  
//   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
//     var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
//     $progressBar
//       .css('background-size', calc + '% 100%')
//       .attr('aria-valuenow', calc );
    
//     $progressBarLabel.text( calc + '% completed' );
//   });
//  $slider.slick({
//    dots: false,
//    arrows:true,
//    infinite: true,
//    speed: 300,
//    slidesToShow: 3,
//    slidesToScroll: 1,
//    adaptiveHeight: false,
//    responsive: [
//      {
//        breakpoint: 1199,
//        settings: {
//          slidesToShow: 3,
//          slidesToScroll: 1
//        }
//      },
//      {
//        breakpoint: 992,
//        settings: {
//          slidesToShow: 3,
//          slidesToScroll: 1
//        }
//      },
//      {
//        breakpoint: 768,
//        settings: {
//          slidesToShow: 2,
//          slidesToScroll: 1
//        }
//      },
//      {
//        breakpoint: 600,
//        settings: {
//          slidesToShow: 1,
//          slidesToScroll: 1
//        }
//      }
//    ]
//  });






//For tab

  // $('ul.tabs').each(function(){
  //     var active, content, links = $(this).find('a');
  //     active = links.first().addClass('active');
  //     content = $(active.attr('href'));
  //     links.not(':first').each(function () {
  //       $($(this).attr('href')).hide();
  //     });
  //     $(this).find('a').click(function(e){
  //       active.removeClass('active');
  //       content.hide();
  //       active = $(this);
  //       content = $($(this).attr('href'));
  //       active.addClass('active');
  //       content.show();
  //       return false;
  //     });
  //   });


    $(".product-count__text span").each(function() {
        let productCount = $(this).html();
        let updatedText = productCount.replace(/products/g, "<i>products</i>"); // 'g' for global replacement
        $(this).html(updatedText);
    });


});


